<template>
  <div v-if="isPermission && isEdit">
    <CCard style="">
      <CCardBody>
        <CRow>
          <CIcon
            size="2xl"
            name="cil-basket"
            class="text-success col-2 col-sm-1 col-lg-1"
          />
          <CCol col="7" sm="9" md="9" lg="9">
            <select
              class="custom-select text-dark"
              v-model="shopObjectId"
              disabled
              id="shop-select"
            >
              <option selected>{{ $t("selectshop") }}</option>
              <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                {{ shop.shopName }} - {{ shop.branchName }}
              </option>
            </select>
          </CCol>
          <div class="col-3 col-sm-2 col-md-2 text-right">
            <CButton
              block
              color="light"
              @click="$router.go(-1)"
              class="align-items-center"
              id="back-button"
            >
              <span
                ><i
                  class="fi fi-rr-arrow-left mr-2"
                  style="position: relative; top: 2px"
                ></i></span
              >{{ $t("back") }}
            </CButton>
          </div>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="shadow-sm" style="border-radius: 0.1rem">
      <CCardBody>
        <CAlert color="danger" v-if="errorAlert" closeButton>
            {{ validateItem }}
        </CAlert>
        <CRow>
          <CCol col="12" class="h3">{{ $t("information") }}</CCol>
        </CRow>
        <CRow>
          <CCol md="6" class="pr-4 pl-4 border-right">
            <div class="form-group">
              <label class="text-dark font-weight-normal">
                {{ $t("supplierName") }} <span class="text-danger">*</span>
              </label>
              <CInput v-model="name" style="margin-bottom: 5px;"  :placeholder="$t('supplierName')" :class="{ 'input-error': validateItem && !name }"/>
              <p style="font-size: 12px; color:red" v-if="validateItem && !name">{{ $t('plsEnterSupplierName') }}</p>
            </div>

            <div class="form-group">
              <label class="text-dark font-weight-normal">
                {{ $t("taxID") }}
              </label>
              <CInput v-model="taxId" :placeholder="$t('taxID')" />
            </div>

            <div class="form-group">
              <label class="text-dark font-weight-normal">
                {{ $t("supplierCode") }}
              </label>
              <CInput v-model="supplierCode" :placeholder="$t('supplierCode')" />
            </div>

            <div class="form-group">
              <label class="text-dark font-weight-normal">
                {{ $t("address") }} <span class="text-danger">*</span>
              </label>
              <CTextarea v-model="address" style="margin-bottom: 5px;" :class="{ 'input-error': validateItem && !address }" :placeholder="$t('address')" rows="3"  />
              <p style="font-size: 12px; color:red;" v-if="validateItem && !address">{{ $t('plsEnterAddress') }}</p>
            </div>
          </CCol>
          <CCol md="6" class="pr-4 pl-4">
            <label class="text-dark font-weight-normal">
              {{ $t("contact") }}
            </label>
            <div class="form-group m-0">
              <label class="text-dark font-weight-normal">
                {{ $t("contactName") }} <span class="text-danger">*</span>
              </label>
              <CInput v-model="contactName" style="margin-bottom: 5px;" :placeholder="$t('contactName')" :class="{ 'input-error': validateItem && !contactName }" />
              <p style="font-size: 12px; color:red" v-if="validateItem && !contactName">{{ $t('plsEnterContactName') }}</p>
            </div>

            <div class="form-group m-0">
              <CRow>
                <CCol md="6">
                  <label class="text-dark font-weight-normal">
                    {{ $t("tel") }} <span class="text-danger">*</span>
                  </label>
                  <CInput v-model="phone" style="margin-bottom: 5px;" :placeholder="$t('tel')" :class="{ 'input-error': validateItem && !phone }" />
                  <p style="font-size: 12px; color:red" v-if="validateItem && !phone">{{ $t('plsEnterTel') }}</p>
                </CCol>
                <CCol md="6">
                  <label class="text-dark font-weight-normal">
                    {{ $t("email") }} <span class="text-danger">*</span>
                  </label>
                  <CInput v-model="email" style="margin-bottom: 5px;" :placeholder="$t('email')" :class="{ 'input-error': validateItem && !email }" />
                  <p style="font-size: 12px; color:red" v-if="validateItem && !email">{{ $t('plsEnterEmail') }}</p>
                </CCol>
              </CRow>
            </div>

            <div class="form-group m-0">
              <label class="text-dark font-weight-normal">
                {{ $t("vat") }}
              </label>
              <CRow>
                <CCol md="6">
                  <select v-model="vatOption" class="custom-select">
                    <option value="Including VAT">{{ $t("incVat") }}</option>
                    <option value="Excluding VAT">{{ $t("excVat") }}</option>
                    <option value="None VAT">{{ $t("noneVat") }}</option>
                  </select>
                </CCol>
                <CCol md="5">
                  <CInput
                    v-model.number="vatPercentage"
                    type="number"
                    :disabled="vatOption === 'None VAT'"
                  />
                </CCol>
                <CCol md="1">
                  <h4 class="mt-2">%</h4>
                </CCol>
              </CRow>
            </div>

            <div class="form-group m-0">
              <label class="text-dark font-weight-normal">
                {{ $t("creditTerm") }}
              </label>
              <CRow>
                <CCol md="6">
                  <CInput v-model.number="creditTerm" type="number" />
                </CCol>
                <CCol md="6" class="mt-2">
                  <span class="text-muted">{{ $t("days") }}</span>
                </CCol>
              </CRow>
            </div>
          </CCol>
        </CRow>
        <hr />
        <CRow>
          <CCol col="10" class="h3">{{ $t("product") }}</CCol>
          <CCol md="2">
            <CButton
              class="btn btn-outline-success btn-block"
              style="display: flex; align-items: center; justify-content: center"
              @click="openSelectProductModal"
            >
              <i class="fi fi-rr-plus" style="margin-right: 8px"></i>
              {{ $t("addProduct") }}
            </CButton>
          </CCol>
        </CRow>
        <CRow v-if="items && items.length != 0" class="mt-3">
          <CCol sm="12" lg="12">
            <table
              id="createAdjustStockTable"
              style="white-space: nowrap"
              class="table table-responsive table-bordered text-dark font-weight-normal"
            >
              <thead>
                <tr>
                  <th class="text-center text-dark font-weight-normal">#</th>
                  <th></th>
                  <th class="text-dark font-weight-normal">{{ $t("pluCode") }}</th>
                  <th class="text-dark font-weight-normal">{{ $t("productName") }}</th>
                  <th class="text-center text-dark font-weight-normal">
                    {{ $t("vatInc") }}
                  </th>
                  <th class="text-dark font-weight-normal">{{ $t("supplierBarcode") }}</th>
                  <th class="text-right text-dark font-weight-normal">
                    {{ $t("stockUnit") }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                  :id="'createAdjustStockRow' + index"
                >
                  <p style="display: none">
                    {{ (item.orderIndex = index) }}
                  </p>
                  <td class="text-center" style="width: 2%">
                    <div style="margin-top: 6px">
                      {{ item.orderIndex + 1 }}
                    </div>
                  </td>
                  <td style="width: 5%">
                    <div
                      v-if="item.remoteImagePath"
                      :style="{
                        'background-image': `url('${item.remoteImagePath}'), url('${noImg}')`,
                        'background-size': 'cover',
                        'background-position': 'center center',
                        width: 'auto',
                        'border-radius': '2px',
                        'aspect-ratio': '1.3',
                        'min-width': '50px',
                      }"
                    ></div>
                    <div
                      v-else
                      style="border-radius: 2px"
                      :style="{
                        'aspect-ratio': '4 / 3',
                        'min-width': '50px',
                        backgroundColor: item.indexColor,
                      }"
                    ></div>
                  </td>
                  <td>
                    <div style="margin-top: 6px">
                      {{ item.productPLU.PLUCode }}
                    </div>
                  </td>
                  <td style="width: 30%">
                    <div style="margin-top: 6px">
                      {{ item.productPLU.name }}
                      ( {{ item.unit ? item.unit.name || "-" : "-" }} /
                      {{ item.productPLU.SKURatio || "1" }} )
                    </div>
                  </td>
                  <td style="width: 10%">
                    <div
                      class="custom-control custom-checkbox"
                      style="display: flex; justify-content: center"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input success cursor"
                        :checked="item.vatType !== 'V'"
                        :disabled="vatOption === 'None VAT'"
                        :id="index"
                      />
                      <label class="custom-control-label cursor" :for="index"> </label>
                    </div>
                  </td>
                  <td :id="'createAdjustStockRowQuantity' + index" style="width: 20%">
                    <input
                      :id="'createAdjustStockRowQuantityInput' + index"
                      class="form-control form-control-md text-right text-dark"
                      v-model="item.supplierPLUCode"
                    />
                  </td>
                  <td :id="'createAdjustStockRowQuantity' + index" style="width: 10%">
                    <input
                      :id="'createAdjustStockRowQuantityInput' + index"
                      type="number"
                      min="0"
                      class="form-control form-control-md text-right text-dark"
                      v-model="item.supplierPrice"
                    />
                  </td>
                  <td class="text-center" style="width: 2%">
                    <CButton
                      :id="'createAdjustStockRowRemoveButton' + index"
                      color="danger"
                      size="sm"
                      @click="isDetailMode ? handleDelete(item.productPLU.objectId) : removeProduct(item.orderIndex)"
                    >
                      <CIcon name="cil-trash"></CIcon>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="text-danger" v-if="warning != ''">{{ warning }}</p>
            <p v-if="duplicateItem != ''" class="text-danger">
              {{ duplicateItem }}
            </p>
          </CCol>
        </CRow>
        <CRow v-else class="mt-3">
          <CCol sm="12" lg="12">
            <CDataTable>
              <template #no-items-view>
                <div class="text-center my-5">
                  <h4 style="color: #ced2d8">
                    {{ $t("noItem") }}
                  </h4>
                </div>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
        <pagination :meta_data="meta_data" v-on:next="getProductSupplier"> </pagination>
        <br />
      </CCardBody>
    </CCard>

    <!-- Footer button -->
    <CCol>
      <div class="row justify-content-end" style="margin: 0">
        <CButton
          class="btn col-lg-2 col-4 shadow-sm font-weight-normal"
          style="font-weight: normal; margin-right: 15px"
          color="danger"
          @click="deleteModal = true"
          v-if="isDetailMode"
        >
          {{ $t("delete") }}
        </CButton>
        <CButton
          class="btn col-lg-2 col-4 shadow-sm font-weight-normal"
          style="background-color: white; font-weight: normal; margin-right: 15px"
          @click="$router.go(-1)"
          v-else
        >
          {{ $t("cancel") }}
        </CButton>

        <CButton
          class="btn btn-success col-lg-2 col-4 font-weight-normal"
          @click="handlePopup"
        >
          {{ $t("confirm") }}
        </CButton>
        <!-- <CButton
          class="btn btn-success col-lg-2 col-4 font-weight-normal"
          v-else
          disabled
        >
          {{ $t("confirm") }}
        </CButton> -->
      </div>
      <br />
    </CCol>

    <!-- Confirm save modal -->
    <CRow>
      <CModal
        :show.sync="popupModal"
        color="success"
        :title="$t('confirmSaveSupplier')"
        centered
        :footer="footer"
      >
        <br />
        <h4 class="text-center">
          {{ $t("confirmSaveSupplier") }}
        </h4>
        <br />
        <template #footer>
          <CRow class="justify-content-center col-md-12">
            <CCol col="6">
              <CButton
                id="createAdjustStockPopupModalCancelButton"
                block
                color="light"
                @click="popupModal = false"
              >
                {{ $t("cancel") }}
              </CButton>
            </CCol>
            <CCol col="6">
              <CButton
                color="success"
                block
                v-if="loadingButton === false"
                v-on:click="saveSupplier"
              >
                {{ $t("save") }}
              </CButton>
              <CButton
                id="createAdjustStockPopupModalSaveDisabledButton"
                block
                color="success"
                v-else-if="loadingButton === true"
                disabled
              >
                <CSpinner color="white" size="sm" /> {{ $t("save") }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </CRow>
    <CModal
      id="supplierDeleteModal"
      color="danger"
      :title="$t('confirmDeletsupplier')"
      :show.sync="deleteModal"
      centered
    >
      <h4 class="mt-4 mb-4 text-center">{{ $t("dialogDeleteSupplier") }}</h4>
      <template #footer>
        <CRow class="justify-content-around col-md-12">
          <CCol col="6">
            <CButton
              id="supplierCancelDeleteButton"
              v-if="loadingButton === false"
              @click="deleteModal = false"
              color="light"
              block
            >
              {{ $t("cancel") }}
            </CButton>
            <CButton v-else-if="loadingButton === true" color="light" disabled block>
              {{ $t("cancel") }}
            </CButton>
          </CCol>
          <CCol col="6">
            <CButton
              id="supplierDeleteButton"
              @click="deleteSupplier"
              v-if="loadingButton === false"
              color="danger"
              block
            >
              {{ $t("delete") }}
            </CButton>
            <CButton
              id="supplierDeleteButtonLoading"
              v-else-if="loadingButton === true"
              color="danger"
              block
              disabled
            >
              <CSpinner color="white" size="sm" />
            </CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>
    <CModal
      id="supplierDeleteItemModal"
      color="danger"
      :title="$t('confirmUnlink')"
      :show.sync="deleteItemModal"
      centered
    >
      <h4 class="mt-4 mb-4 text-center">{{ $t("confirmUnlinkProductSupplier") }}</h4>
      <template #footer>
        <CRow class="justify-content-around col-md-12">
          <CCol col="6">
            <CButton
              id="supplierCancelDeleteButton"
              v-if="loadingButton === false"
              @click="deleteItemModal = false"
              color="light"
              block
            >
              {{ $t("cancel") }}
            </CButton>
            <CButton v-else-if="loadingButton === true" color="light" disabled block>
              {{ $t("cancel") }}
            </CButton>
          </CCol>
          <CCol col="6">
            <CButton
              id="supplierDeleteButton"
              @click="deleteProductSupplier"
              color="danger"
              v-if="loadingButton === false"
              block
            >
              {{ $t("delete") }}
            </CButton>
            <CButton
              id="supplierDeleteButtonLoading"
              v-else-if="loadingButton === true"
              color="danger"
              block
              disabled
            >
              <CSpinner color="white" size="sm" />
            </CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>
    <AppProductPicker
      ref="select_product_component"
      :limitItem="limitSelectProduct"
      @update-selected-items="updateSelectedProducts"
    >
    </AppProductPicker>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/services/local";
import util from "@/util/util";
import permis from "@/util/permission";
import pos from "@/services/local";
import AppProductPicker from "@/components/AppProductPicker";
import { cond } from "lodash";
import Pagination from "@/containers/Pagination";

export default {
  components: {
    AppProductPicker,
    Pagination,
  },
  data() {
    return {
      data: [],
      itemList: [],
      items: [],
      shop: this.$store.getters.shopObjectId,
      alert: false,
      searchBy: "name",
      label: "name",
      keyword: "",
      placeHolderInputText: "พิมพ์ชื่อสินค้าที่ต้องการค้นหา .​.​.",
      autoCompleteResult: [],
      autoCompleteProgress: false,
      validateShop: "",
      validateItem: "",
      popupModal: false,
      footer: "",
      loadingButton: false,
      warning: "",
      duplicateItem: "",
      AddProductModal: false,
      AddCheckStockModal: false,
      keywordEntered: "",
      selectedItems: [],
      all: false,
      note: "",
      checkStockItem: [],
      selectedCategory: "",
      limitSelectProduct: 100,
      name: "",
      taxId: "",
      supplierCode: "",
      address: "",
      contactName: "",
      phone: "",
      email: "",
      vatOption: "Including VAT",
      vatPercentage: 0,
      creditTerm: 0,
      deleteModal: false,
      id: null,
      productSupplier: [],
      supplier_code: null,
      deleteItemModal: false,
      objectIdToDelete: '',
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      newSupplierObjectId: '',
      errorAlert: false
    };
  },
  computed: {
    ...mapGetters(["shops", "users", "date", "access"]),
    isPermission() {
      return permis.findPermissionRead("inventory", "/inventory/adjust-stock");
    },
    isEdit() {
      return permis.findPermissionEdit("inventory", "/inventory/adjust-stock");
    },
    uid() {
      return `${localStorage.getItem("shopsUid")}`;
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    noImg() {
      return process.env.VUE_APP_NOIMAGE;
    },
    supplierObjectId: {
      get() {
        return this.isDetailMode ? this.$route.params.objectId : this.newSupplierObjectId;
      },
      set(value) {
        this.newSupplierObjectId = value;
      }
    },
    isCreateMode() {
      return this.$route.path.includes("/create");
    },
    isDetailMode() {
      return this.$route.path.includes("/supplier/detail/");
    },
  },
  created() {
    this.shop = this.shops.find((i) => i.objectId === this.shop);
    if (this.isDetailMode) {
      this.getSupplier();
      this.getProductSupplier();
    }
  },
  methods: {
    getSupplier() {
      const uid = this.uid;
      this.loadingButton = true
      const shopObjectId = this.shopObjectId;
      const supObjectId = this.$route.params.objectId;
      const params = { shopObjectId: shopObjectId, objectId: supObjectId };
      let url = "/api/v3.0/supplier/data";
      let itemList = [];
      const headers = { shopObjectId: this.$store.getters.shopObjectId };

      pos
        .get(url, { params, headers })
        .then((res) => {
          const data = res.data.data;
          this.name = data.name;
          this.taxId = data.taxId;
          this.supplierCode = data.supplierCode;
          this.address = data.address;
          this.contactName = data.contactName;
          this.phone = data.phone;
          this.email = data.email;
          this.vatOption = data.vatOption;
          this.vatPercentage = data.vatPercentage;
          this.creditTerm = data.creditTerm;
          this.id = data.id;
          this.supplier_code = data.supplier_code;
          this.loadingButton = false
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    },
    openSelectProductModal(index) {
      this.selectedIndex = index;
      this.$refs.select_product_component.openModal();
    },
    updateSelectedProducts(selectedProducts) {
      const newItems = selectedProducts.map((product) => ({
        productPLU: product.ProductPRU?.productPLU || {},
        vatType: product.vatType || "V",
        remoteImagePath: product.remoteImagePath || "",
        indexColor: util.generateColor(product.indexColor),
        supplierPrice: product.Price || 0,
        unit: product.unit || "-",
        supplierPLUCode: ''
      }));

      const merged = [...this.items, ...newItems];
      const unique = [];

      const seen = new Set();

      for (const item of merged) {
        const id = item.productPLU.objectId;
        if (!seen.has(id)) {
          seen.add(id);
          unique.push(item);
        }
      }

      this.items = unique;
    },
    noImgUrl(event) {
      event.target.src = process.env.VUE_APP_NOIMAGE;
    },
    handlePopup() {
      this.validateItem = '';
      this.validateShop = '';
      if (!this.name || !this.address || !this.phone || !this.email || !this.contactName) {
        this.validateItem = this.$t("valtdateMember");
        this.errorAlert = true
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        setTimeout(() => {
          this.errorAlert = false
        }, 5000);
        this.popupModal = false;
        return;
      }
      if (this.shopObjectId === "") {
        this.validateShop = this.$t("selectShopPlease");
        this.popupModal = false;
        return;
      }
      this.popupModal = true;
    },
    handleDelete(objectId){
      this.objectIdToDelete = objectId
      this.deleteItemModal = true
    },
    removeProduct(orderIndex) {
      let items = this.items;
      let newItems = items.filter((item) => item.orderIndex != orderIndex);
      this.items = newItems;
      this.selectedItems.forEach((selectedItem) => {
        if (!newItems.some((item) => item.productPLUId === selectedItem.id)) {
          selectedItem.selected = false;
        }
      });
      this.selectedItems = this.selectedItems.filter(
        (selectedItem) => selectedItem.selected
      );
    },
    saveSupplier() {
      this.loadingButton = true;
      const uid = this.uid;
      const headers = { shopObjectId: this.shopObjectId };
      let method = this.isDetailMode ? "patch" : "post";
      const supObjectId = this.$route.params.objectId;
      let data = {
        name: this.name,
        taxId: this.taxId,
        supplierCode: this.supplierCode,
        address: this.address,
        contactName: this.contactName,
        phone: this.phone,
        email: this.email,
        vatOption: this.vatOption,
        vatPercentage: this.vatPercentage,
        creditTerm: this.creditTerm,
      };
      if (this.isDetailMode) {
        data.objectId = supObjectId;
      }
      pos({
        method: method,
        url: "/api/v3.0/supplier",
        data: data,
        headers: headers,
      })
        .then((res) => {
          // let objectId = res.data.data.objectId
          const data = res.data.data;
          this.name = data.name;
          this.taxId = data.taxId;
          this.supplierCode = data.supplierCode;
          this.address = data.address;
          this.contactName = data.contactName;
          this.phone = data.phone;
          this.email = data.email;
          this.vatOption = data.vatOption;
          this.vatPercentage = data.vatPercentage;
          this.creditTerm = data.creditTerm;
          this.id = data.id;
          this.supplier_code = data.supplier_code;
          this.supplierObjectId = data.objectId;
          this.loadingButton = false
          this.$nextTick(() => {
            this.linkProductsToSupplier();
          });
          
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteSupplier() {
      this.loadingButton = true;
      const uid = this.uid;
      const headers = { shopObjectId: this.shopObjectId };
      const supObjectId = this.$route.params.objectId;
      let data = {
        objectId: supObjectId,
      };
      if (this.isDetailMode) {
        data.objectId = supObjectId;
      }
      pos({
        method: "delete",
        url: "/api/v3.0/supplier",
        data: data,
        headers: headers,
      })
        .then((res) => {
          // let objectId = res.data.data.objectId
          this.loadingButton = false
          this.$router.push("/supplier");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getProductSupplier(page = 1) {
      this.loadingButton = true;
      const uid = this.uid;
      const headers = { shopObjectId: this.shopObjectId };
      const supObjectId = this.$route.params.objectId;
      let params = {
        page: page,
        limit: 50,
        supplierObjectId: supObjectId,
      };
      pos({
        method: "get",
        url: "/api/v3.0/supplier/product",
        headers: headers,
        params: params,
      })
        .then((res) => {
          const errorCode = res.error?.code;
          if (errorCode && errorCode !== 0) {
            this.items = [];
            this.loadingButton = false;
          } else {
            const data = res.data.data || [];
            this.items = data.map((item) => ({
              productPLU: item.productPLU,
              vatType: item.vatType,
              remoteImagePath: item.ProductPLU?.remoteImagePath || "",
              indexColor: util.generateColor(item.ProductPLU?.indexColor),
              supplierPrice: item.supplierPrice || 0,
              unit: item.ProductPLU?.unit || "-",
              supplierPLUCode: item.supplierPLUCode || ''
            }));
            this.loadingButton = false;
            if (res.data.paginate.items == undefined) {
              this.meta_data.items = 0;
            } else {
              this.meta_data.items = res.data.paginate.items;
            }
            this.meta_data.last_page = res.data.paginate.pageCount;
            this.meta_data.current_page = res.data.paginate.currentPage;
            this.meta_data.itemCount = res.data.paginate.itemCount;
            this.meta_data.limit = res.data.paginate.perPage;
          }

          this.loadingButton = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteProductSupplier() {
      this.loadingButton = true;
      const uid = this.uid;
      const headers = { shopObjectId: this.shopObjectId };
      const supObjectId = this.$route.params.objectId;
      let data = {
        supplier: {
          objectId: supObjectId,
        },
        productPLU: {
          objectId: this.objectIdToDelete,
        },
      };

      pos({
        method: "delete",
        url: "/api/v3.0/supplier/product",
        data: data,
        headers: headers,
        // params: params,
      })
        .then((res) => {
          this.loadingButton = false;
          this.deleteItemModal = false
          this.objectIdToDelete = ''
          this.getProductSupplier(1)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    floatValue(value) {
      return parseFloat(value);
    },
    linkProductsToSupplier() {
      const linkedProducts = this.items.map((item) => ({
        supplier: {
          name: this.name,
          objectId: this.supplierObjectId,
          id: this.id,
          supplier_code: this.supplier_code,
        },
        productPLU: {
          objectId: item.productPLU.objectId,
          PLUCode: item.productPLU.PLUCode,
          id: item.productPLU.id,
          name: item.productPLU.name,
        },
        supplierPLUCode: item.supplierPLUCode,
        supplierPrice: parseFloat(item.supplierPrice),
        vatType: item.vatType,
      }));
      this.productSupplier = linkedProducts;
      this.saveProductSupplier();
    },
    saveProductSupplier() {
      this.loadingButton = true;
      const uid = this.uid;
      const headers = { shopObjectId: this.shopObjectId };
      const supObjectId = this.$route.params.objectId;
      let data = this.productSupplier;
      const url = "/api/v3.0/supplier/product";
      pos({
        method: "post",
        url: url,
        data: data,
        headers: headers,
      })
        .then((res) => {
          this.loadingButton = false
          this.$router.push("/supplier");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.input-error input,
.input-error textarea{
  border: 1px solid red !important;
  box-shadow: none !important;
}
</style>